export default "__VITE_ASSET__Cz6vfvX5__"